module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Stok Pesan")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Stok Pesan")])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('el-select', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "Pilih Wilayah"
    },
    model: {
      value: (_vm.kode_wilayah),
      callback: function($$v) {
        _vm.kode_wilayah = $$v
      },
      expression: "kode_wilayah"
    }
  }, _vm._l((_vm.wilayah1), function(item) {
    return _c('el-option', {
      key: item.kode,
      attrs: {
        "label": item.nama,
        "value": item.kode
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticClass: "filter-item",
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": function($event) {
        return _vm.getData1(_vm.kode_wilayah)
      }
    }
  }, [_vm._v("Cari")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModal),
      expression: "loadingModal"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData2,
      "responsive": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "label": "Nomor PB",
      "min-width": "200",
      "prop": "nomor_pb"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Tanggal",
      "min-width": "100",
      "prop": "tgl"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Jam",
      "min-width": "100",
      "prop": "jam"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Item Total",
      "min-width": "100",
      "prop": "item_total"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Diproses Gudang",
      "min-width": "200",
      "prop": "diproses_gudang"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Dibuat Oleh",
      "min-width": "200",
      "prop": "dibuat_oleh"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Toko",
      "min-width": "200",
      "prop": "toko"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Pilihan",
      "align": "right",
      "header-align": "right",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.diproses_gudang == 'BELUM') ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Proses",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "small",
            "icon": "el-icon-refresh"
          },
          on: {
            "click": function($event) {
              return _vm.confirmProses(scope.row)
            }
          }
        })], 1) : _vm._e(), _vm._v(" "), (!scope.row.edit && !scope.row.add) ? _c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "Print",
            "placement": "top-start"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "success",
            "size": "small",
            "icon": "ti-eye"
          },
          on: {
            "click": function($event) {
              return _vm.confirmDet(scope.row)
            }
          }
        })], 1) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "total": _vm.tableData.length,
      "page-size": _vm.page_size,
      "current-page": _vm.current_page
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalPrint),
      expression: "loadingModalPrint"
    }],
    attrs: {
      "title": "Permintaan Pesanan Barang",
      "visible": _vm.dialogFormPrintVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormPrintVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("WILAYAH")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(": " + _vm._s(_vm.stok_wilayah))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("TANGGAL")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(": " + _vm._s(_vm.stok_tanggal))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("AREA")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(": " + _vm._s(_vm.stok_area))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("NOMOR")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v(": " + _vm._s(_vm.stok_nomor))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("TOKO")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(": " + _vm._s(_vm.stok_toko))])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_vm._v("DIBUAT OLEH")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(": " + _vm._s(_vm.stok_dibuat_oleh))])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModal1),
      expression: "loadingModal1"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData1,
      "responsive": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "NO",
      "prop": "no",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "SKU",
      "prop": "sku"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Item",
      "prop": "nama"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Qty"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                      " + _vm._s(scope.row.qty) + " " + _vm._s(scope.row.satuan) + "\n                    ")]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_vm._v("Print")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalAdd),
      expression: "loadingModalAdd"
    }],
    attrs: {
      "title": "Tambah Area",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.form,
      "status-icon": "",
      "rules": _vm.rules1,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Wilayah",
      "label-width": _vm.formLabelWidth,
      "prop": "kode_wilayah"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Pilih Wilayah"
    },
    model: {
      value: (_vm.form.kode_wilayah),
      callback: function($$v) {
        _vm.$set(_vm.form, "kode_wilayah", $$v)
      },
      expression: "form.kode_wilayah"
    }
  }, _vm._l((_vm.wilayah), function(item) {
    return _c('el-option', {
      key: item.kode,
      attrs: {
        "label": item.nama,
        "value": item.kode
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nama",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmAdd('form')
      }
    }
  }, [_vm._v("Submit")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalEdit),
      expression: "loadingModalEdit"
    }],
    attrs: {
      "title": "Edit Area",
      "visible": _vm.dialogFormWilEdit
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormWilEdit = $event
      }
    }
  }, [_c('el-form', {
    ref: "form1",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.form1,
      "status-icon": "",
      "rules": _vm.rules,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Kode",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "disabled": ""
    },
    model: {
      value: (_vm.form1.kode),
      callback: function($$v) {
        _vm.$set(_vm.form1, "kode", $$v)
      },
      expression: "form1.kode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nama",
      "prop": "name",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form1.name),
      callback: function($$v) {
        _vm.$set(_vm.form1, "name", $$v)
      },
      expression: "form1.name"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormWilEdit = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmEdit1('form1')
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalArea),
      expression: "loadingModalArea"
    }],
    attrs: {
      "title": "Tambah Toko",
      "visible": _vm.dialogFormArea
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormArea = $event
      }
    }
  }, [_c('el-form', {
    ref: "form2",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.form2,
      "status-icon": "",
      "rules": _vm.rules2,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Area",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off",
      "disabled": ""
    },
    model: {
      value: (_vm.form2.name),
      callback: function($$v) {
        _vm.$set(_vm.form2, "name", $$v)
      },
      expression: "form2.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nama Toko",
      "prop": "toko",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form2.toko),
      callback: function($$v) {
        _vm.$set(_vm.form2, "toko", $$v)
      },
      expression: "form2.toko"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Alamat Toko",
      "prop": "alamat_toko",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.form2.alamat_toko),
      callback: function($$v) {
        _vm.$set(_vm.form2, "alamat_toko", $$v)
      },
      expression: "form2.alamat_toko"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.loadingModalArea = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmArea1('form2')
      }
    }
  }, [_vm._v("Confirm")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalDel1),
      expression: "loadingModalDel1"
    }],
    attrs: {
      "title": "Hapus Area",
      "visible": _vm.dialogFormWilDel
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormWilDel = $event
      }
    }
  }, [_c('h4', [_vm._v("Hapus Area ini?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormWilDel = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmDel1()
      }
    }
  }, [_vm._v("Confirm")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Info",
      "visible": _vm.dialogFormInfo
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormInfo = $event
      }
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.message))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormInfo = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormInfo = false
      }
    }
  }, [_vm._v("OK")])], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalDel),
      expression: "loadingModalDel"
    }],
    attrs: {
      "title": "Proses Barang",
      "visible": _vm.dialogFormWilDel
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormWilDel = $event
      }
    }
  }, [_c('h4', [_vm._v("Proses Barang ini?")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormWilDel = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.confirmProses1()
      }
    }
  }, [_vm._v("Confirm")])], 1)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03389da5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/master_data/StokPesan.vue
// module id = 1333
// module chunks = 2